<header class="header">
    <div class="header__title">
        <img src="https://contentdeliveryciam.blob.core.windows.net/spark/deloitte.png" alt="">
        <div class="header__label">Next Generation Deloitte Technology</div>
    </div>
    <div class="header__nav">
        <div class="menu">
            <div (click)="openMenu()" class="burguer">
                <!-- <img src="../../../assets/images/menu.svg"> -->
                <div class="menu-icon" [class.open]="open" (click)="open = !open">
                <span></span>
                <span></span>
                <span></span>
                </div>                 
            </div>
            <ul class="main-menu">
                <li><a 
                    [routerLink]="'./dashboard'" 
                    routerLinkActive="current"
                    >Dashboard</a></li>
                <li><a 
                    [routerLink]="'./organization-management'" 
                    routerLinkActive="current"
                    >Organization management</a></li>
                <li><a 
                    [routerLink]="'./user-management'" 
                    routerLinkActive="current"
                    >User management</a></li>
            </ul>                    
        </div>
        <div>
            <div class="profile">
                <button (click)="displayProfile()" type="button" class="reset-btn nav-btn">
                    <img src="https://contentdeliveryciam.blob.core.windows.net/spark/ic_round-search.svg">
                </button>
                <button (click)="displayProfile()" type="button" class="reset-btn nav-btn">
                    <img src="https://contentdeliveryciam.blob.core.windows.net/spark/person-outline.svg">
                    <img src="https://contentdeliveryciam.blob.core.windows.net/spark/mdi_chevron-up.svg">
                </button>
                <div class="profile__container">
                    <ng-container *ngIf="profileVisible">
                        <app-profile></app-profile>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div class="reponsive_menu" [class.visible]="open">
        <ul class="reponsive_menu__items">
            <li><a
                (click)="open = false"
                [routerLink]="'./dashboard'" 
                routerLinkActive="reponsive_menu__current"
                >Dashboard</a></li>
            <li><a
                (click)="open = false" 
                [routerLink]="'./organization-management'" 
                routerLinkActive="reponsive_menu__current"
                >Organization management</a></li>
            <li><a
                (click)="open = false" 
                [routerLink]="'./user-management'" 
                routerLinkActive="reponsive_menu__current"
                >User management</a></li>
        </ul>
    </div>    
    <div class="header__title_section">
        <h3>{{ title() }}</h3>
    </div>
</header>
